
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise/overview",
      function () {
        return require("private-next-pages/enterprise/overview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise/overview"])
      });
    }
  